import { call, put, select } from 'redux-saga/effects';
import {
  getMobileInsurance as getMobileInsuranceAda,
} from '@bitComponents/adabyronThird/mobileInsurance';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

const normalizeMobileInsurance = (response, modality) => {
  let normalizedResponse = {};
  if (response && Array.isArray(response)) {
    const selectedInsuranceModality = response.find(insurance => insurance.modalidad === modality);

    if (selectedInsuranceModality) {
      const {
        tarifa, modalidad, valor,
      } = selectedInsuranceModality;
      let { promo, nombre } = selectedInsuranceModality;
      if (promo) {
        promo = promo.toLowerCase();
        promo = promo.charAt(0).toUpperCase() + promo.slice(1);
      }
      if (nombre) {
        nombre = nombre.toLowerCase();
        nombre = `Seguro móvil ${nombre}`;
      }
      normalizedResponse = {
        name: nombre,
        price: tarifa,
        promo,
        promoPrice: promo && '0',
        modality: modalidad,
        unity: valor,
      };
    }
  }
  return normalizedResponse;
};

export function* getMobileInsurance(params) {
  const {
    reduxUpdate, normalizeHttpErrors, productOffering, storage, insurance,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const data = {
      productOffering,
      storage,
    };
    const response = yield call(getMobileInsuranceAda, data, context);
    const mobileInsurance = normalizeMobileInsurance(response, insurance);
    yield put(successUpdate(mobileInsurance));
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_MOBILE_INSURANCE, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
  }
}
